import React from "react";
import AntdAutoComplete, {AutoCompleteProps} from "antd/lib/auto-complete";
// import { withError, useTracker, TrackEventType, getTrackEventInfo} from '@fishx/tracker';
import { withError } from '@fishx/tracker';

const Option = AntdAutoComplete.Option;
interface FACProps extends AutoCompleteProps {
  forwardedRef?: any;
}
interface FCProps extends React.FC<FACProps> {
  Option: typeof Option;
}

const AutoComplete: FCProps = (props) => {
  const {forwardedRef, ...rest} = props;
  return <AntdAutoComplete {...rest} ref={forwardedRef} />;
};

AutoComplete.Option = Option;
AutoComplete.displayName = 'AutoComplete';
export default withError(AutoComplete);



// WEBPACK FOOTER //
// ./src/components/auto-complete/index.tsx